import React, { Component } from 'react'
import Titulo from '../comum/Titulo'
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { connect } from 'react-redux';
import { Field, change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import { Link, withRouter } from 'react-router-dom';
import FormCadastroEmissaoCteOS from './FormCadastroEmissaoCteOS';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import ptBR from 'date-fns/locale/pt-BR';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import { renderField } from '../../util/arraysUtil';
import FormCadastroPercursoCteOs from './FormCadastroPercursoCteOs';
import ModalCadastrarPercursoCteOs from './ModalCadastrarPercursoCteOs';
import salvarrEmissaoCteOS from '../../actions/cteos/salvarrEmissaoCteOS';
import { showSuccessMsg } from '../../util/messagesUtil';
import { modalTransporte, situacaoTransmissaoCteOs } from '../../util/constantsUtil';
import moment from 'moment';
import { gerarHashForString } from '../../util/stringUtil';
import buscarOpcoesFiltrosEmissaoesCteOs from '../../actions/cteos/buscarOpcoesFiltrosEmissaoesCteOs';
import { showAlertMsg } from '../../util/messagesUtil';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export class PainelCadastroEmissaoCteOS extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.selecionarDestino = this.selecionarDestino.bind(this);
        this.selecionarOrigem = this.selecionarOrigem.bind(this);

        this.state = {
            dataEmissao: null,
            dataViagem: null,
            tomadorSelecionado: null,
            percursoCteOS: [],
            modalTransporte: modalTransporte[0].chave,
            exibeLabelCidade: true,
            naturezaOperacaoSelecionado: null,
            veiculoSelecionado: null,
            tipoServicoSelecionado: null,
            responsavelSeguroSelecioando: [],
            seguroSelecionado: null,
            tipoFretamentoSelecionado: []
        }
    }

    componentDidMount() {
        this.limparCampos();
        this.props.changeFieldValue('formularioCadastroCteOS', '', '');

        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarOpcoesFiltrosEmissaoesCteOs(this.props.empresaSelecionada.id);
        }

        this.carregarFormulario();
    }

    carregarFormulario() {
        this.props.changeFieldValue('formularioCadastroCteOS', 'modelo', 67);
        this.props.changeFieldValue('formularioCadastroCteOS', 'dv', 0);
        this.props.changeFieldValue('formularioCadastroCteOS', 'modal', {
            label: modalTransporte[0].valor,
            value: modalTransporte[0].chave
        });

        if (this.props.emissaoCteOsSelecionado.cidadeOrigem !== null) {
            const cidadeDeOrigem = {
                id: this.props.emissaoCteOsSelecionado.cidadeOrigem.id,
                nome: this.props.emissaoCteOsSelecionado.cidadeOrigem.nome,
                uf: this.props.emissaoCteOsSelecionado.cidadeOrigem.uf
            };
            this.props.selecionarOrigem(cidadeDeOrigem);
        }

        if (this.props.emissaoCteOsSelecionado.cidadeDestino !== null) {
            const cidadeDeDestino = {
                id: this.props.emissaoCteOsSelecionado.cidadeDestino.id,
                nome: this.props.emissaoCteOsSelecionado.cidadeDestino.nome,
                uf: this.props.emissaoCteOsSelecionado.cidadeDestino.uf
            };

            this.props.selecionarDestino(cidadeDeDestino);
        }

        if (this.props.emissaoCteOsSelecionado.veiculo) {
            this.props.changeFieldValue('formularioCadastroCteOS', 'veiculo', {
                label: this.props.emissaoCteOsSelecionado.veiculo.nome,
                value: this.props.emissaoCteOsSelecionado.veiculo.id,
            });
        }

        if (this.props.emissaoCteOsSelecionado.tomador) {
            this.props.changeFieldValue('formularioCadastroCteOS', 'tomador', {
                label: this.props.emissaoCteOsSelecionado.tomador.nomePessoa ?  this.props.emissaoCteOsSelecionado.tomador.nomePessoa : this.props.emissaoCteOsSelecionado.tomador.nomeFantasia,
                value: this.props.emissaoCteOsSelecionado.tomador.id,
            });
        }

        if (this.props.emissaoCteOsSelecionado.tipoServico) {
            this.props.changeFieldValue('formularioCadastroCteOS', 'tipoServico', {
                label: this.props.emissaoCteOsSelecionado.tipoServico.valor,
                value: this.props.emissaoCteOsSelecionado.tipoServico.chave,
            });
        }

        if (this.props.emissaoCteOsSelecionado.responsavelSeguro) {
            this.props.changeFieldValue('formularioCadastroCteOS', 'responsavelSeguro', {
                label: this.props.emissaoCteOsSelecionado.responsavelSeguro.valor,
                value: this.props.emissaoCteOsSelecionado.responsavelSeguro.chave,
            });
        }

        if (this.props.emissaoCteOsSelecionado.seguro) {
            this.props.changeFieldValue('formularioCadastroCteOS', 'seguro', {
                label: this.props.emissaoCteOsSelecionado.seguro.valor,
                value: this.props.emissaoCteOsSelecionado.seguro.chave,
            });
        }

        if (this.props.emissaoCteOsSelecionado.tipoFretamento) {
            this.props.changeFieldValue('formularioCadastroCteOS', 'tipoFretamento', {
                label: this.props.emissaoCteOsSelecionado.tipoFretamento.valor,
                value: this.props.emissaoCteOsSelecionado.tipoFretamento.chave,
            });
        }

        if (this.props.emissaoCteOsSelecionado.naturezaOperacao) {
            const descricao = `${this.props.emissaoCteOsSelecionado.naturezaOperacao.codigo} ${this.props.emissaoCteOsSelecionado.naturezaOperacao.descricao}`
            this.props.changeFieldValue('formularioCadastroCteOS', 'naturezaOperacao', {
                label: descricao,
                value: this.props.emissaoCteOsSelecionado.naturezaOperacao.id,
            });
        }

        let percursosCteOsDto = [];
        if (this.props.emissaoCteOsSelecionado.percursosCteOsDto) {
            const percursos = this.props.emissaoCteOsSelecionado.percursosCteOsDto;
            percursosCteOsDto = percursos.map(it => {
                return {
                    hash: gerarHashForString(`${it.uf}`),
                    ...it
                }
            });
        }

        this.setState({
            dataViagem: this.props.emissaoCteOsSelecionado.dataViagem
                ? moment(this.props.emissaoCteOsSelecionado.dataViagem).toDate() : null,
            dataEmissao: this.props.emissaoCteOsSelecionado.dataEmissao
                ? moment(this.props.emissaoCteOsSelecionado.dataEmissao).toDate() : null,
            percursoCteOS: percursosCteOsDto
        });

        if (this.props.emissaoCteOsSelecionado.dataViagem) {
            this.props.changeFieldValue('formularioCadastroCteOS', 'horaViagem', moment(this.props.emissaoCteOsSelecionado.dataViagem).format('HH:mm'));
            
        }
        if (this.props.emissaoCteOsSelecionado.dataEmissao) {
            this.props.changeFieldValue('formularioCadastroCteOS', 'horaEmissao', moment(this.props.emissaoCteOsSelecionado.dataEmissao).format('HH:mm'));
        }

    }

    adicioanrPercursoCteOS(percurso) {
        if (this.state.percursoCteOS.filter(it => it.hash === percurso.hash).length === 0) {
            const percursos = [...this.state.percursoCteOS];
            percursos.push(percurso);
            this.setState({
                percursoCteOS: percursos
            });
        }
    }

    removerPercursoCteOS(hash) {
        this.setState({
            percursoCteOS: this.state.percursoCteOS.filter(it => !(it.hash == hash))
        });
    }

    limpaViagens(sentido) {
        if (sentido === 'pesquisaOrigem') {
            this.selecionarOrigem(null)
        }
        if (sentido === 'pesquisaDestino') {
            this.selecionarDestino(null)
        }

    }

    selecionarDestino(destino) {
        this.props.selecionarDestino(destino);
    }

    selecionarOrigem(origem) {        
        this.props.selecionarOrigem(origem);
    }

    selecionarDataEmissao(date) {
        if (date) {
            this.setState({ dataEmissao: date });
        } else {
            this.setState({ dataEmissao: null });
        }
    }

    selecionarDataViagem(date) {
        if (date) {
            this.setState({ dataViagem: date });
        } else {
            this.setState({ dataViagem: null });
        }
    }

    exibirCampoBusca() {
        if (this.props.id && this.state.exibeLabelCidade) {
            return this.exibirCidade();
        }

        return ((!this.props.id || !this.state.exibeLabelCidade) && <React.Fragment>
            <div className="col-12 col-sm-5 col-md-5 mb-6 mt-3">
                <label htmlFor="pesquisaOrigem">Cidade Inicio:</label>
                <SelecaoCidadeAutocomplete limparViagens={this.limpaViagens.bind(this)}
                    name='pesquisaOrigem'
                    selecionarCidade={this.selecionarOrigem}
                    value={this.props.origem}
                    ehVenda={true}
                />
            </div>
            <div className="col-12 col-sm-5 col-md-5 mb-6 mt-3">
                <label htmlFor="pesquisaOrigem">Cidade Términio:</label>
                <SelecaoCidadeAutocomplete name='pesquisaDestino'
                    limparViagens={this.limpaViagens.bind(this)}
                    selecionarCidade={this.selecionarDestino}
                    value={this.props.destino}
                    ehVenda={true}
                />
            </div>
            {this.props.id && <div className="col-12 col-sm-2 col-md-2 mb-6 mt-3"
                onClick={() => this.setState({ exibeLabelCidade: true })}>
                <i className="material-icons float-right" style={{cursor: 'pointer'}}>clear</i>
            </div>}

            <Field name="origem" type="hidden" component={renderField} css="form-control col-md-12" />
            <Field name="destino" type="hidden" component={renderField} css="form-control col-md-12" />
        </React.Fragment>)
    }

    exibirCidade() {
        return (
            <>
                <div className="col-12 col-sm-12 col-md-8 mb-8 mt-2" style={{ display: 'flex', alignItems: 'flex-end'}}>
                    <div>
                        <label htmlFor="pesquisaOrigem">Cidade Inicio:</label>
                        <span className='ml-1'>{this.props.emissaoCteOsSelecionado.cidadeOrigem.nomeComUf}</span>
                    </div>
                    <div className='ml-4'>
                        <label htmlFor="pesquisaOrigem">Cidade Término:</label>
                        <span className='ml-1'>{this.props.emissaoCteOsSelecionado.cidadeDestino.nomeComUf}</span>
                    </div>
                    <div>
                    {this.exibeBotaoSalvarCasoEmissaoCteOsSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento() &&<button type="button" className="btn btn-editar " title='Editar Cidades' style={{ cursor: 'pointer' }}
                         onClick={() => this.setState({ exibeLabelCidade: false })}>
                            <i className="material-icons nav-icon">&#xe150;</i>
                        </button>}
                    </div>
                </div>
                           
            </>
        )
    }

    handleSelecionarTipoFretamento(e) {
        this.setState({
            tipoFretamentoSelecionado: e
        })
    }

    handleSelecionarSeguro(e) {
        this.setState({
            seguroSelecionado: e
        })
    }

    handleSelecionarResponsavelSeguro(e) {
        this.setState({
            responsavelSeguroSelecioando: e
        })
    }

    handleSelecionarTipoServico(e) {
        this.setState({
            tipoServicoSelecionado: e
        })
    }

    handleSelecionarNaturezaOperacao(e) {
        this.setState({
            naturezaOperacaoSelecionado: e
        })
    }

    handleSelecionarTomador(e) {
        this.setState({
            tomadorSelecionado: e
        })
    }

    handleModalTransporte(e) {
        this.setState({
            modalTransporte: e && e.value ? e.value : null
        })
    }

    handleSelecionarVeiculo(e) {
        this.setState({
            veiculoSelecionado: e
        })
    }

    montarParamentos(values) {
        let cidadeOrigemId;
        let cidadeDestinoId;
        if (this.props.origem && this.props.origem.id && this.props.destino && this.props.destino.id) {
            cidadeOrigemId = this.props.origem.id;
            cidadeDestinoId = this.props.destino.id;
        }

        if (this.props.id) {
            if (this.state.exibeLabelCidade) {
                cidadeOrigemId = this.props.emissaoCteOsSelecionado.cidadeOrigem.id
                cidadeDestinoId = this.props.emissaoCteOsSelecionado.cidadeDestino.id
            }
        }

        let veiculoId;
        if(this.state.veiculoSelecionado && this.state.veiculoSelecionado.value) {
            veiculoId = this.state.veiculoSelecionado.value;
        } else if (this.props.emissaoCteOsSelecionado.veiculo && this.props.emissaoCteOsSelecionado.veiculo.id) {
            veiculoId = this.props.emissaoCteOsSelecionado.veiculo.id
        }

        let seguro = null;
        if(this.state.seguroSelecionado && this.state.seguroSelecionado.value) {
            seguro = this.state.seguroSelecionado.value
        } else if (this.props.emissaoCteOsSelecionado.seguro && this.props.emissaoCteOsSelecionado.seguro.chave) {
            seguro = this.props.emissaoCteOsSelecionado.seguro.chave
        }

        return {
            id: this.props.id,            
            tipoServico: this.state.tipoServicoSelecionado && this.state.tipoServicoSelecionado.value ? this.state.tipoServicoSelecionado.value
                : this.props.emissaoCteOsSelecionado.tipoServico.chave,
            cidadeOrigemId: cidadeOrigemId,
            cidadeDestinoId: cidadeDestinoId,
            tomador: this.state.tomadorSelecionado && this.state.tomadorSelecionado.value ? this.state.tomadorSelecionado.value 
                : this.props.emissaoCteOsSelecionado.tomador.id,
            naturezaOperacao: this.state.naturezaOperacaoSelecionado && this.state.naturezaOperacaoSelecionado.value ? this.state.naturezaOperacaoSelecionado.value 
                : this.props.emissaoCteOsSelecionado.naturezaOperacao.id,
            descricaoServico: values.descricaoServico,
            quantidadeCarga: values.quantidadeCarga,
            tabelaFrete: values.tabelaFrete,
            valorServico: values.valorServico.replace('R$', ''),
            termoAutorizacaoFretamento: values.termoAutorizacaoFretamento,
            tipoFretamento: this.state.tipoFretamentoSelecionado && this.state.tipoFretamentoSelecionado.value ? this.state.tipoFretamentoSelecionado.value 
                : this.props.emissaoCteOsSelecionado.tipoFretamento.chave,
            dataViagem: this.state.dataViagem,
            horaViagem: this.props.horaViagem,
            veiculoId: veiculoId,
            usuarioId: this.props.idUsuario,
            empresaId: this.props.empresaSelecionada.id,
            percursoCteOsDto: this.state.percursoCteOS,
            responsavelSeguro: this.state.responsavelSeguroSelecioando && this.state.responsavelSeguroSelecioando.value ? this.state.responsavelSeguroSelecioando.value 
                : this.props.emissaoCteOsSelecionado.responsavelSeguro.chave,
            seguro: seguro,
            
        }
    }

    limparCampos() {
        this.selecionarOrigem(null);
        this.selecionarDestino(null);
        this.setState({
            dataEmissao: null,
            dataViagem: null,
            tomadorSelecionado: null,
            naturezaOperacaoSelecionado: null,
            percursoCteOS: []
        });
        this.props.reset('formularioCadastroCteOS');

    }

    submit(values) {
        const parametros = this.montarParamentos(values);
        if(!parametros.cidadeOrigemId || !parametros.cidadeDestinoId) {
            showAlertMsg('É necessário informa a cidade de início e cidade de términio');
            return;
        }
        
        this.props.salvarrEmissaoCteOS(parametros)
            .then(() => {
                showSuccessMsg('A emissão CT-e OS foi salvo com sucesso!');
                this.limparCampos();
                this.props.history.push('/painel-cte-os');
            });
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;

        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <div>
                    <div className="col-md-12">
                        <Titulo texto={`${this.props.id ? 'Editar' : 'Nova'} CT-e OS`} urlRetorno="/painel-cte-os" />
                    </div>
                    <form onSubmit={handleSubmit(this.submit)}>
                        <div className="vx-table-card mt-3">
                            <ul className="nav nav-tabs border-bottom mb-0" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" id="emissaoCteOS-tab" data-toggle="tab"
                                       href="#EMISSAO_CTE_OS" role="tab" aria-controls="emissaoCteOS"
                                       aria-selected="true" onClick={(e) => e.preventDefault()}>
                                        <span className="material-icons mr-1" style={{fontSize:15,verticalAlign:'middle'}}>receipt_long</span>
                                        Emissão CT-e OS
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" id="profile-tab" data-toggle="tab"
                                       href="#PERCURSO" role="tab" aria-controls="profile"
                                       aria-selected="false" onClick={(e) => e.preventDefault()}>
                                        <span className="material-icons mr-1" style={{fontSize:15,verticalAlign:'middle'}}>route</span>
                                        Percurso
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content" id="myTabContent" style={{ padding: '20px 0' }}>
                                <div className="tab-pane fade show active" id="EMISSAO_CTE_OS" role="tabpanel" aria-labelledby="emissaoCteOS-tab">
                                    <FormCadastroEmissaoCteOS
                                        dataEmissao={this.state.dataEmissao}
                                        dataViagem={this.state.dataViagem}
                                        selecionarDataEmissao={this.selecionarDataEmissao.bind(this)}
                                        selecionarDataViagem={this.selecionarDataViagem.bind(this)}
                                        exibirCampoBusca={this.exibirCampoBusca.bind(this)}
                                        handleSelecionarTomador={this.handleSelecionarTomador.bind(this)}
                                        handleModalTransporte={this.handleModalTransporte.bind(this)}
                                        handleSelecionarNaturezaOperacao={this.handleSelecionarNaturezaOperacao.bind(this)}
                                        handleSelecionarVeiculo={this.handleSelecionarVeiculo.bind(this)}
                                        handleSelecionarTipoServico={this.handleSelecionarTipoServico.bind(this)}
                                        handleSelecionarResponsavelSeguro={this.handleSelecionarResponsavelSeguro.bind(this)}
                                        handleSelecionarSeguro={this.handleSelecionarSeguro.bind(this)}
                                        handleSelecionarTipoFretamento={this.handleSelecionarTipoFretamento.bind(this)}
                                        exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento={this.exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento.bind(this)}
                                    />
                                </div>
                                <div className="tab-pane fade" id="PERCURSO" role="tabpanel" aria-labelledby="profile-tab">
                                    <FormCadastroPercursoCteOs
                                        percursoCteOS={this.state.percursoCteOS}
                                        removerPercursoCteOS={this.removerPercursoCteOS.bind(this)}
                                        exibeBotaoSalvarCasoEmissaoCteOsSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento={this.exibeBotaoSalvarCasoEmissaoCteOsSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="vx-footer-actions mt-3">
                            <div className="vx-footer-left">
                                <Link className="vx-btn-secondary" to='/painel-cte-os'>
                                    <span className="material-icons">arrow_back</span>
                                    Voltar
                                </Link>
                            </div>
                            <div className="vx-footer-right">
                                {this.exibeBotaoSalvarCasoEmissaoCteOsSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento() &&
                                    <button type="submit" className="vx-btn-primary"
                                        disabled={invalid || submitting || !this.state.dataViagem || !this.props.horaViagem ||
                                            !this.props.origem || !this.props.destino || this.props.valorServico === 'R$0,00'}>
                                        <span className="material-icons">save</span>
                                        Salvar
                                    </button>}
                            </div>
                        </div>
                    </form>
                    <ModalCadastrarPercursoCteOs
                        percursoCteOS={this.state.percursoCteOS}
                        adicioanrPercursoCteOS={this.adicioanrPercursoCteOS.bind(this)}
                    />
                </div>
            </Autorizacao>
        )
    }

    exibeBotaoSalvarCasoEmissaoCteOsSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento() {
        return !this.props.emissaoCteOsSelecionado || (this.props.emissaoCteOsSelecionado.ultimoHistoricoEmissaoCteOs == null ||
            (this.props.emissaoCteOsSelecionado.ultimoHistoricoEmissaoCteOs != null &&
                this.props.emissaoCteOsSelecionado.ultimoHistoricoEmissaoCteOs.situacaotransmissao.chave == situacaoTransmissaoCteOs.erro));
    }

    exibeCamposParaApenasLeituraCasoEmissaoCteOsNaoSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento() {
        return !this.exibeBotaoSalvarCasoEmissaoCteOsSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento();
    }
}

export const mapStateToProps = state => {

    return {
        initialValues: {
            numeroCteOS: state.emissaoCteOsSelecionado.numero,
            modelo: state.emissaoCteOsSelecionado.modelo,
            serie: state.emissaoCteOsSelecionado.serie,
            modal: state.emissaoCteOsSelecionado.modal,
            descricaoServico: state.emissaoCteOsSelecionado.descricaoServico,
            quantidadeCarga: `${state.emissaoCteOsSelecionado.quantidadeCarga}`,
            tabelaFrete: state.emissaoCteOsSelecionado.tabelaFrete,
            valorServico: state.emissaoCteOsSelecionado.valorServico,
            termoAutorizacaoFretamento: state.emissaoCteOsSelecionado.termoAutorizacaoFretamento
            
        },
        id: state.emissaoCteOsSelecionado.id,
        emissaoCteOsSelecionado: state.emissaoCteOsSelecionado,
        empresaSelecionada: state.empresaSelecionada,
        numeroCteOS: formValueSelector('formularioCadastroCteOS')(state, 'numeroCteOS'),
        modelo: formValueSelector('formularioCadastroCteOS')(state, 'modelo'),
        serie: formValueSelector('formularioCadastroCteOS')(state, 'serie'),
        dataEmissao: formValueSelector('formularioCadastroCteOS')(state, 'dataEmissao'),
        modal: formValueSelector('formularioCadastroCteOS')(state, 'modal'),
        descricaoServico: formValueSelector('formularioCadastroCteOS')(state, 'descricaoServico'),
        quantidadeCarga: formValueSelector('formularioCadastroCteOS')(state, 'quantidadeCarga'),
        horaViagem: formValueSelector('formularioCadastroCteOS')(state, 'horaViagem'),
        horaEmissao: formValueSelector('formularioCadastroCteOS')(state, 'horaEmissao'),
        tabelaFrete: formValueSelector('formularioCadastroCteOS')(state, 'tabelaFrete'),
        valorServico: formValueSelector('formularioCadastroCteOS')(state, 'valorServico'),
        termoAutorizacaoFretamento: formValueSelector('formularioCadastroCteOS')(state, 'termoAutorizacaoFretamento'),
        dataViagem: formValueSelector('formularioCadastroCteOS')(state, 'dataViagem'),
        numeroRegistroEstadual: formValueSelector('formularioCadastroCteOS')(state, 'numeroRegistroEstadual'),
        veiculos: state.veiculos.veiculos,
        origem: state.origem,
        destino: state.destino,
        idUsuario: state.authentication.idUsuario,
    }
};

export default withRouter(connect(mapStateToProps,
    {
        selecionarOrigem,
        selecionarDestino,
        salvarrEmissaoCteOS,
        changeFieldValue,
        buscarOpcoesFiltrosEmissaoesCteOs
    })(reduxForm({
        form: 'formularioCadastroCteOS'
    })(PainelCadastroEmissaoCteOS)))